import { Radio as AntRadio } from 'antd'
import styled from 'styled-components'

export const Radio = styled(AntRadio)`
  && {
    &:not(.ant-radio-wrapper-disabled):hover .ant-radio-inner,
    .ant-radio:not(.ant-checkbox-disabled):hover .ant-radio-inner {
      transition: none;
      border-color: ${(props) => props.theme.colors.radio.border};
      outline: 1px solid ${(props) => props.theme.colors.checkbox.focus};
      outline-offset: 1px;
    }
  }
`
